import { useMediaQuery } from '@abyss/web/hooks/useMediaQuery';
import { Button } from '@abyss/web/ui/Button';
import { Flex } from '@abyss/web/ui/Flex';
import { Heading } from '@abyss/web/ui/Heading';
import { IconSymbol } from '@abyss/web/ui/IconSymbol';
import { Text } from '@abyss/web/ui/Text';
import find from 'lodash/find';
import React from 'react';

import { ConstantsLagoon } from '../../../../common/ConstantsLagoon';
import { mobileOnly } from '../../../../common/ConstantsStyles';
import { useLagoon } from '../../../../hooks/useLagoon';

export const CompareSmartChoiceHeader = ({ handleBackButtonClick }) => {
  const lagoonData = useLagoon('ui-messaging')();
  const mobileScreen = useMediaQuery(mobileOnly);
  const compare_provider = find(lagoonData, {
    key: ConstantsLagoon.UI_MESSAGING.COMPARE_PROVIDERS,
  })?.message;
  const heading = find(lagoonData, {
    key: mobileScreen
      ? ConstantsLagoon.UI_MESSAGING.COMPARE.COMPARE_SWAP_PROVIDERS_HEADING
      : ConstantsLagoon.UI_MESSAGING.COMPARE.COMPARE_BACK_TO_RESULTS_HEADING,
  })?.message;
  const button = find(lagoonData, {
    key: ConstantsLagoon.UI_MESSAGING.COMPARE.COMPARE_BACK_TO_RESULTS_BUTTON,
  })?.message;

  return (
    <React.Fragment>
      <Heading display="h2" offset={1}>
        {compare_provider}
      </Heading>
      <Text color="$gray7">{heading}</Text>
      <Flex>
        <Button
          css={{ marginTop: '24px' }}
          data-testid="back-button"
          onClick={handleBackButtonClick}
        >
          <IconSymbol
            css={{ marginRight: '8px' }}
            icon="arrow_back"
            size="sm"
          />
          {button}
        </Button>
      </Flex>
    </React.Fragment>
  );
};
